/**
 * 层级配置项
 */
export const ALL_STEP = ['shi', 'qu', 'school', 'jie', 'ban', 'clou', 'data']
export const STEP_CONFIG = {
    'shi': {
        name: '市',
        props: {
            bottoms: {
                modify: true,
                del: true
            },
            status: {}
        }
    },
    'qu': {
        name: '区',
        props: {
            bottoms: {
                modify: true,
                del: true
            },
            status: {}
        }
    },
    'school': {
        name: '学校',
        props: {
            bottoms: {
                modify: true,
                del: true
            },
            status: {}
        }
    },
    'jie': {
        name: '届',
        props: {
            bottoms: {
                modify: true,
                del: true
            },
            status: {}
        }
    },
    'ban': {
        name: '班',
        props: {
            bottoms: {
                modify: true,
                del: true,
                down: true,
                // submit: true
            },
            status: {
                // submit: true,
                // down: false
            }
        }
    },
    'clou': {
        name: '库',
        props: {
            bottoms: {
                // empty: true,
                down: true
            },
            status: {}
        }
    },
    'data': {
        name: '数据',
        props: {
            bottoms: {
                del: true,
                down: true
            },
            status: {}
        }
    }
}